'use strict';
import ApiActions from '../../../../actions/api';
import Constants from '../../checkout/constants.js';
import Store from './store';


class Actions {
    static signout(cb) {

        ApiActions.delete(
            '/api/logout',
            {},
            Store,
            Constants.SIGN_OUT,
            Constants.SIGN_OUT_RESPONSE,
            cb
        );
    }
}


export default Actions;
